import { getFallbackValueIfNull } from 'owa-options-core';
import messageListLayoutStore from '../store/messageListLayoutStore';
import {
    setShowPreviewLinesOptionMutator,
    selectTempPreviewLinesOptionMutator,
} from '../actions/selectMessageListLayoutOption';
import getFallbackPreviewLinesToShow from './getFallbackPreviewLinesToShow';
import saveOcsShowPreviewLinesSetting from './saveOcsShowPreviewLinesSetting';

export async function saveMessagePreviewOption(): Promise<void> {
    const tempValue = messageListLayoutStore().tempPreviewLinesInListView;
    await onMessagePreviewSelection(tempValue);
}

export default async function onMessagePreviewSelection(linesToShow: number | null): Promise<void> {
    const optionState = messageListLayoutStore();
    const savedValue: number =
        optionState.showPreviewLinesInListView ?? getFallbackPreviewLinesToShow();
    const newValue: number = getFallbackValueIfNull(linesToShow, savedValue);
    setShowPreviewLinesOptionMutator(newValue);
    selectTempPreviewLinesOptionMutator(newValue);
    await saveOcsShowPreviewLinesSetting(newValue);
}
